import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Stock from "~/views/stock"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [
      { url: "/quotes/list" },
      { url: "/stocks/info" },
      { url: "/dividends/list" },
      { url: "/assets/constants" },
    ],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)
  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Stock.getInitialProps = getInitialProps

export default Stock
